import PerfectScrollbar from 'perfect-scrollbar';

var psAllVideo;
var psAllVideoMobile;

if($('.js-all-video-scroll').length > 0) {
	psAllVideo = new PerfectScrollbar('.js-all-video-scroll', {
		wheelSpeed: 0.5,
		wheelPropagation: true,
		minScrollbarLength: 258,
	});

	psAllVideoMobile = new PerfectScrollbar('.js-all-video-scroll-mobile', {
		wheelSpeed: 0.5,
		wheelPropagation: true,
		minScrollbarLength: 258,
	});
}


// WEBPACK FOOTER //
// ./src/js/pages/longrid/all-video-scroll.js